module.exports = __webpack_public_path__ + "img/Qianru_Sun@2x.c4412364.png";